import { Box, TextField } from "@mui/material";
import React from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { BSSConfirmDialog} from "../../../form/BSSDialog";
import {LocalizationProvider, StaticDatePicker} from '@mui/x-date-pickers'
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import * as locales from 'date-fns/locale'
import { commonFormats } from "../../../../lib/dateshelper";
import { format, parse } from "date-fns";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material";
const {logger} = useBSSLogger();

/**
 * 
 * @param {Date} v 
 */
const dateToFilter = (v) => {
    try {
        let value = null;

        if(v !== null){
            value = format(v, commonFormats.JS2JAVA, new Date())
        }
        
        return value;
    } catch(err){
        logger.debug("data non valida da js a java", v, err);
        return null;
    }
    
}

const filterToDate = (v) => {
    try {

        let value = null;

        if(v !== null){
            value = format(parse(v, commonFormats.JS2JAVA, new Date()), "dd-MM-yyyy", new Date())
        }

        return value;
    }catch(err){
        logger.debug("data non valida da java a js", v, err);
        return null;
    }
}

const DialogFiltroData = ({stati, filtri, setFiltri, calendario, setCalendario}) => {

    const theme = useTheme();

    const filtraPerData = (da, a) => {

        const dadata = dateToFilter(da);
        const adata = dateToFilter(a);

        const nuoviFiltri ={            
            dadata,
            adata
        }
        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                ...nuoviFiltri
            }, 
            skip: 0
        });
        setCalendario({mostra: false})
    }

    return (
        <BSSConfirmDialog 
            title={__t("rangedidate")}                                                        
            open={calendario.mostra} 
            undoAction={e => setCalendario({mostra: false})} 
            confirmAction={e => {
                filtraPerData(calendario.da, calendario.a)
            }}
            sx={{"& .MuiDialogContent-root": {p: 0, overflowX: "hidden"}}}
            maxWidth={"lg"}
        >
            <>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={locales.it}  >
                    {/* <StaticDateRangePicker 
                        value={[calendario.da, calendario.a]}
                        displayStaticWrapperAs="desktop"
                        calendars={1}                                                                
                        onChange={(newValue) => {
                            logger.debug("cambio valore date range picker", newValue)
                            const [da, a] = newValue;
                            setCalendario({
                                ...calendario,
                                da,
                                a
                            })
                        }} 
                        renderInput={(startProps, endProps) => (
                            <>
                                <TextField {...startProps} />
                                <Box sx={{ mx: 2 }}> to </Box>
                                <TextField {...endProps} />
                            </>
                        )}                                                                                                                      
                    />  */}
                    <Grid container>
                        {["da", "a"].map((ctx, i) => {

                            const label = __t(ctx === 'da' ? "inizio" : "fine");

                            const data = ((calendario?.[ctx] ?? null) && format(calendario[ctx], "dd/MM/yyyy")) ?? null;

                            const minDate = calendario['a'];
                            const maxDate = calendario['da'];
                            const specificProps = ctx === 'a' ? {minDate: calendario['da']} : {maxDate: calendario['a']};

                            return (
                                <Grid key={i} item xs={6}>
                                    <Stack>
                                        <Typography variant="h6" sx={{px: 1, textAlign: 'center'}}>
                                            {label} {data && data}
                                        </Typography>
                                        <StaticDatePicker 
                                            value={calendario[ctx]}
                                            displayStaticWrapperAs="desktop"
                                            calendars={1}      
                                            {...specificProps}                                               
                                            onChange={(newValue) => {
                                                logger.debug("cambio valore date range", label, newValue)
                                                setCalendario({...calendario, [ctx]: newValue})
                                            }} 
                                            renderInput={(props) => (
                                                <>
                                                    <TextField {...props} />                            
                                                </>
                                            )}                                                                                                                                              
                                        /> 
                                    </Stack>
                                    
                                </Grid>
                            )
                        })}
                        
                    </Grid>
                    
                    
                </LocalizationProvider>
            </>
            
        </BSSConfirmDialog>
    )
}

export default DialogFiltroData;
export {
    dateToFilter,
    filterToDate
}